import { useSearchParams } from "react-router-dom";

/**
 * Читает пагинацию из URL. Те же параметры, что пишет CrudList, — списочные
 * представления делят одно состояние страницы и размера страницы.
 */
export const usePaginationParams = () => {
  const [searchParams] = useSearchParams();

  const page = Number(searchParams.get("page")) || 0;
  const rowsPerPage = Number(searchParams.get("rowsPerPage")) || 10;

  return { page, rowsPerPage };
};
